import React, {
  useEffect,
  useRef,
  useState
} from 'react';
import './play-game.styles.scss';
import {
  useNavigate,
  useParams
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  getGameDataFromDb,
  getPlayerDataFromDb,
  getUniqueDocumentFromDb,
  getLatestGameMessageFromDb,
  getPlayersFromPlayerDocs,
  getGameElementsFromRtDb,
  getLatestGameActivity,
  getActionItemsFromFirebase,
  getGameElementShortList
} from '@/utils/getDataFromDb';
import PlayerGameContent from '@/components/PLAYER/player-game-content.component';
import {
  Desktop,
  LargeTablet,
  Mobile,
  Tablet
} from '@/utils/responsiveQueries';
import PlayHeadBar from '@/components/PLAYER/play-game-head-bar/play-head-bar.component';
import Loader from '@/components/loader/loader.comp';
import {
  UseCloudFunction,
  UseCloudGameTransactions,
  auth
} from '@/utils/firebase.utils';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import { off } from 'firebase/database';
import PlayHeadBarMobile from '@/components/PLAYER/play-game-head-bar/play-head-mobile.component';
import LegalApprovalModal from '@/components/SHARED/legal-approval-modal/legal-approval-modal.component';
import { checkForEarnedLevels } from '@/utils/checkForEarnedLevels';
import { getQueryFromFirestore, getQueryFromRtDb } from '@/utils/getDataFromDbSimplified';
import AnnouncementModal from '@/components/SHARED/announcements/announcement-modal.component';

const PlayGamePage = () => {

  const userProfile = useSelector(state => state.userData.userProfile);
  // Keep latest profile accessible inside delayed callbacks without re-running effect setup.
  const userProfileRef = useRef(userProfile);
  const authCheckTimeoutRef = useRef(null);
  const playerDataRetryTimeoutRef = useRef(null);
  const [gameData, setGameData] = useState(null);
  const [playerData, setPlayerData] = useState(null);
  const [gameElements, setGameElements] = useState(null);
  const [playerActivity, setPlayerActivity] = useState(null);
  const [actionItems, setActionItems] = useState(null);
  const [gameStats, setGameStats] = useState(null);
  const [playerList, setPlayerList] = useState(null);
  const [teamMembers, setTeamMembers] = useState({});
  const [myTeams, setMyTeams] = useState(null);
  const [latestMessage, setLatestMessage] = useState(null);
  const { gamePath } = useParams();
  const playerDataRef = useRef(); // to hold latest playerData for level check
  const elementsRef = useRef();
  const activityRef = useRef();
  const actionItemsRef = useRef();
  const playerListRef = useRef();
  const alreadyChecked = useRef();
  const navigate = useNavigate();
  let gameListener;
  let playerListener;
  let elementsListener;
  let activityListener;
  let checkVisInterval;
  let actionItemsListener;
  let statsListener;
  let playerListListener;
  let teamListener;
  let messageListener;

  useEffect(() => {
    userProfileRef.current = userProfile;
  }, [userProfile])

  useEffect(() => {

    // checkElementVisibility();
    checkForAuth();
    checkVisInterval = setInterval(() => {
      // checkElementVisibility();
    }, 100000)

    function checkForAuth(attempt = 0) {
      const currentlySignedInUser = auth.currentUser;
      const appId = userProfileRef.current?.appId;
      if (currentlySignedInUser && appId) {
        getGameData();
        return;
      }
      // First load can race Firebase auth + profile hydration; retry briefly before logout.
      if (attempt >= 10) {
        console.log('logging out: missing auth or appId');
        navigate('/logout');
        return;
      }
      authCheckTimeoutRef.current = setTimeout(() => {
        checkForAuth(attempt + 1);
      }, 500);
    }

    return () => {
      window.localStorage.removeItem('gameElements');
      window.localStorage.removeItem('playerActivity');
      window.localStorage.removeItem('actionItems');
      if (authCheckTimeoutRef.current) clearTimeout(authCheckTimeoutRef.current);
      if (playerDataRetryTimeoutRef.current) clearTimeout(playerDataRetryTimeoutRef.current);
      if (gameListener) gameListener();
      if (playerListener) playerListener();
      if (elementsListener) elementsListener();
      if (activityListener) activityListener();
      if (checkVisInterval) clearInterval(checkVisInterval);
      if (actionItemsListener) actionItemsListener();
      if (statsListener) statsListener();
      if (playerListListener) off(playerListListener);
      if (teamListener) teamListener();
      if (messageListener) messageListener();
    }
  }, [])

  useEffect(() => {
    if (!userProfile) { return; }
    // getGameData()
  }, [userProfile])


  // useEffect(() => {
  //     if (!teamMembers || !gameElements || !playerData) return;
  //     let tempElements = {...gameElements};
  //     const playerTeams = 
  //         Object.values(teamMembers)
  //         .filter(m => m.members.includes(playerData.playerId))
  //         .map(m => m.teamId);
  //     // console.log(playerTeams);
  //     // console.log(teamMembers);
  //     for (let el of Object.values(tempElements)) {
  //         if (
  //             el.opt_prereqTeams && 
  //             el.opt_prereqTeams.length > 0
  //         ) {
  //             let included = false;
  //             for (let t of el.opt_prereqTeams) {
  //                 if (playerTeams.includes(t)) {
  //                     included = true;
  //                 }
  //             }
  //             if (!included) {
  //                 delete tempElements[el.id];
  //             }    
  //         }
  //     }
  //     setGameElements(tempElements);
  // }, [teamMembers, playerData, gameElements])

  useEffect(() => {
    if (!playerData || !gameElements || !gameData) return;
    // if (alreadyChecked.current) return;
    // checkForEarnedLevels();
    if (playerDataRef.current?.points !== playerData.points) {
      checkForEarnedLevels(gameElements, playerData, gameData);
    }
    playerDataRef.current = { ...playerData }; // keep ref up to date
  }, [playerData, gameElements, gameData])

  async function signPlayerOut(playerId) {
    const res = await UseCloudFunction('resetPlayerSignOut', { 'playerId': playerId })
    console.log(res);
    navigate('/logout');
  }

  function getGameData() {
    getGameDataFromDb({
      'gamePath': gamePath,
      'status': 'active',
      'once': true,
      'callback': callback,
      // 'handleListener': handleListener
    })
    function callback(dataObj) {
      const data = Object.values(dataObj)[0];
      setGameData(data);
      changeDocumentTitle(`Gamably | ${data.gameName}`, data.icon);
      // change var(--primary) to game color
      var r = document.querySelector(':root');
      r.style.setProperty('--primary', data.color);
      r.style.setProperty('--primary-trans', data.color + 'a6');
      getPlayerDataWhenReady(data.gameId);
      getGameElements(data.gameId);
      getGameStats(data.gameId);
      getLeaderList(data.gameId);
      getLatestMessage(data.gameId);
    }
    // function handleListener(unsub) {
    //     gameListener = unsub;
    // }
  }

  function getPlayerDataWhenReady(gameId, attempt = 0) {
    const appId = userProfileRef.current?.appId;
    if (appId) {
      getPlayerData(gameId, appId);
      return;
    }
    // Never query players without appId: getPlayerDataFromDb would otherwise return all players.
    if (attempt >= 10) {
      console.log('logging out: missing userProfile.appId');
      navigate('/logout');
      return;
    }
    playerDataRetryTimeoutRef.current = setTimeout(() => {
      getPlayerDataWhenReady(gameId, attempt + 1);
    }, 300);
  }

  function getPlayerData(gameId, appId) {
    getPlayerDataFromDb({
      'gameId': gameId,
      'appId': appId,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      console.log(data);
      if (data.status !== 'active') {
        navigate('/logout');
        return;
      }
      if (data.signout) {
        signPlayerOut(data.playerId);
        return;
      }
      const processedUser = processNewStuff(data);
      setPlayerData(processedUser);
      getActionItems(data.gameId, data.playerId);
      getTeamMembers(data.gameId, data.playerId);
      // getGameActivity(data.gameId, data.playerId);
    }
    function handleListener(unsub) {
      playerListener = unsub;
    }
  }

  function processNewStuff(playerData) {
    const tempPlayer = { ...playerData }
    if (!playerData.newStuff) return tempPlayer;
    // go through elements in playerData.newStuff and remove
    // items, points, etc. from playerData
    for (let stuff of tempPlayer.newStuff) {
      if (!stuff.data) continue;
      for (let d of stuff.data) {
        if (d.type === 'xp' && tempPlayer.points > 0) {
          tempPlayer.points -= d.quantity;
        } else if (d.type === 'currency' && tempPlayer.currencyTotal > 0) {
          tempPlayer.currency -= d.quantity;
          tempPlayer.currencyTotal -= d.quantity;
        } else if (d.type === 'item') {
          tempPlayer.items[d.id].count -= d.quantity;
        } else if (d.type === 'badge') {
          tempPlayer.badges[d.id].count -= d.quantity;
        }
      }
    }
    return tempPlayer;
  }

  function updatePlayerData(data) {
    setPlayerData(data);
  }

  function getGameElements(gameId) {
    getGameElementShortList({
      'gameId': gameId,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      // console.log('element update')
      // console.log(data);
      const now = new Date().getTime();
      let obj = {};
      for (let el of Object.values(data)) {
        if (
          el.status !== 'active' ||
          el.type === 'secretCode'
        ) {
          // delete elements[el.id];
          continue;
        }
        obj[el.id] = el;
      }
      // console.log(obj);
      elementsRef.current = { ...obj };
      setGameElements(elementsRef.current);
      // checkElementVisibility();
    }
    function handleListener(unsub) {
      elementsListener = unsub;
    }
  }


  function getActionItems(gameId, playerId) {
    getQueryFromFirestore({
      'path': `games/${gameId}/actionItems`,
      'queryArray': [
        {
          'field': 'playerId',
          'operator': '==',
          'value': playerId
        }
      ],
      'callback': callback,
      'handleListener': handleListener

    })
    function callback(data) {
      actionItemsRef.current = { ...actionItemsRef.current, ...{ [data.id]: data } }
      setActionItems(actionItemsRef.current);
    }
    function handleListener(unsub) {
      actionItemsListener = unsub
    }
  }

  function getGameStats(gameId) {
    getUniqueDocumentFromDb({
      'collection': `games/${gameId}/gameStats`,
      'docId': `${gameId}-gameStats`,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      setGameStats(data);
    }
    function handleListener(unsub) {
      statsListener = unsub;
    }
  }

  function getLeaderList(gameId) {
    getQueryFromRtDb({
      'path': `games/${gameId}/leaderList`,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      // console.log(data);
      playerListRef.current = {
        ...playerListRef.current,
        ...data
      }
      let playerObj = {}
      for (let p of Object.values(playerListRef.current)) {
        if (
          !p.team
        ) {
          playerObj[p.playerId] = p
        }
      }
      setPlayerList(playerObj)
    }
    function handleListener(unsub) {
      playerListListener = unsub;
    }
  }

  function getTeamMembers(gameId, playerId) {
    getUniqueDocumentFromDb({
      "collection": `games/${gameId}/teamMembers`,
      "docId": `${gameId}-teamMembers`,
      "callback": callback,
      "handleListener": handleListener
    })
    function callback(data) {
      if (!data) return;
      setTeamMembers(data);
      let myTeamArr = [];
      for (let team of Object.values(data)) {
        if (team.members && team.members.includes(playerId)) {
          myTeamArr.push(team.path);
        }
      }
      setMyTeams([...myTeamArr]);
    }
    function handleListener(unsub) {
      teamListener = unsub;
    }
  }

  async function getLatestMessage(gameId) {
    getLatestGameMessageFromDb({
      'gameId': gameId,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      setLatestMessage(data)
    }
    function handleListener(unsub) {
      messageListener = unsub;
    }
  }

  return (
    <div>
      {
        (gameData && playerData)
          ?
          <div className='play-game-page' style={
            (gameData.bg.type === 'gradient')
              ?
              { 'background': `linear-gradient(to bottom, ${gameData.bg.hexTop}, ${gameData.bg.hexBottom})` }
              :
              { 'backgroundImage': `url("${gameData.bg.url}")` } // no-repeat center center fixed
          }>
            <Desktop>
              <PlayHeadBar
                gameData={gameData}
                playerData={playerData}
                playerActivity={playerActivity}
                gameElements={gameElements} />
              <div className='play-game-container'>
                <div className='play-game-content'>
                  <PlayerGameContent
                    gameData={gameData}
                    playerData={playerData}
                    updatePlayerData={updatePlayerData}
                    gameElements={gameElements}
                    actionItems={actionItems}
                    gameStats={gameStats}
                    playerList={playerList}
                    teamMembers={teamMembers}
                    myTeams={myTeams}
                    latestMessage={latestMessage}
                  />
                </div>
              </div>
            </Desktop>

            <LargeTablet>
              <PlayHeadBar
                gameData={gameData}
                playerData={playerData}
                playerActivity={playerActivity}
                gameElements={gameElements} />
              <PlayerGameContent
                gameData={gameData}
                playerData={playerData}
                updatePlayerData={updatePlayerData}
                gameElements={gameElements}
                actionItems={actionItems}
                gameStats={gameStats}
                playerList={playerList}
                teamMembers={teamMembers}
                myTeams={myTeams}
                latestMessage={latestMessage}
              />
            </LargeTablet>

            <Tablet>
              <PlayHeadBarMobile
                gameData={gameData}
                playerData={playerData}
                playerActivity={playerActivity}
                gameElements={gameElements}
                teamMembers={teamMembers} />
              <PlayerGameContent
                gameData={gameData}
                playerData={playerData}
                updatePlayerData={updatePlayerData}
                gameElements={gameElements}
                actionItems={actionItems}
                gameStats={gameStats}
                playerList={playerList}
                teamMembers={teamMembers}
                myTeams={myTeams}
                latestMessage={latestMessage}
              />
            </Tablet>

            <Mobile>
              <PlayHeadBarMobile
                gameData={gameData}
                playerData={playerData}
                playerActivity={playerActivity}
                gameElements={gameElements}
                teamMembers={teamMembers} />
              <PlayerGameContent
                gameData={gameData}
                playerData={playerData}
                updatePlayerData={updatePlayerData}
                gameElements={gameElements}
                actionItems={actionItems}
                gameStats={gameStats}
                playerList={playerList}
                teamMembers={teamMembers}
                latestMessage={latestMessage}
              />
            </Mobile>
          </div>
          :
          <div className='loading-page'>
            <Loader />
          </div>
      }
      <LegalApprovalModal
        playerData={playerData} />
      <AnnouncementModal />
    </div>
  )
}

export default PlayGamePage